import React from 'react';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import {
  isDevelopmentEnvironment,
  getCurrentBsaEnvironment,
  getCurrentBsaEnvironmentLabel
} from '../../helpers/bsaConfig';

const BsaEnvironmentIndicator = () => {
  if (!isDevelopmentEnvironment()) {
    return null;
  }

  const color = getCurrentBsaEnvironment() === 'prod' ? 'warning' : 'info';

  return (
    <Badge color={color} className="d-inline-flex align-items-center">
      <FontAwesomeIcon icon={faServer} className="me-1" />
      {getCurrentBsaEnvironmentLabel()}
    </Badge>
  );
};

export default BsaEnvironmentIndicator;
